import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { LOGO_CRESCENT } from "./data";
import { SocialLinks } from "./SocialLinks";
import { BagButton } from "./cart/CartDrawer";

const LINKS = [
  { label: "Manifesto", id: "manifesto-section" },
  { label: "Shop", id: "product-showcase-section" },
  { label: "Palestine Edition", id: "palestine-section" },
  { label: "Identity", id: "brand-story-section" },
];

export const Nav = ({ offset = false }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.querySelector(`[data-testid="${id}"]`);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="header-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed left-0 right-0 z-50 transition-all duration-500 ${offset ? "top-9" : "top-0"} ${
        scrolled
          ? "backdrop-blur-xl bg-[#ffffff]/80 border-b border-[#e3e2dc]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
        >
          <img
            src={LOGO_CRESCENT}
            alt="Deen District"
            className="h-9 w-9 object-contain transition-transform duration-500 group-hover:rotate-[8deg]"
          />
          <span className="font-display text-[12px] sm:text-sm font-extrabold tracking-[0.18em] sm:tracking-[0.22em] uppercase">
            Deen District
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="relative text-[12px] font-mono-d uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#0a0a0b] transition-colors duration-300 group"
            >
              {l.label}
              <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-[#ff2a85] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
          <Link
            to="/about"
            data-testid="nav-link-about"
            className="relative text-[12px] font-mono-d uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#0a0a0b] transition-colors duration-300 group"
          >
            About
            <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-[#ff2a85] transition-all duration-300 group-hover:w-full" />
          </Link>
          <Link to="/wholesale" data-testid="nav-link-wholesale" className="relative text-[12px] font-mono-d uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#0a0a0b] transition-colors duration-300 group">
            Stockists
            <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-[#ff2a85] transition-all duration-300 group-hover:w-full" />
          </Link>
          <Link to="/contact" data-testid="nav-link-contact" className="relative text-[12px] font-mono-d uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#0a0a0b] transition-colors duration-300 group">
            Contact
            <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-[#ff2a85] transition-all duration-300 group-hover:w-full" />
          </Link>
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <SocialLinks prefix="nav" size="sm" className="hidden sm:flex" />
          <BagButton testId="nav-bag-button" />
          <button
            data-testid="nav-vip-button"
            onClick={() => scrollTo("email-signup-section")}
            className="px-4 sm:px-5 py-2.5 rounded-full text-[10px] sm:text-[11px] font-mono-d uppercase tracking-[0.15em] sm:tracking-[0.2em] font-medium border border-[#ff2a85]/50 text-[#0a0a0b] hover:bg-[#ff2a85] hover:text-white hover:border-[#ff2a85] hover:shadow-[0_0_25px_-4px_rgba(255,42,133,0.6)] transition-all duration-300"
          >
            Pre-Order
          </button>
        </div>
      </div>
      <div className="sm:hidden flex justify-center pb-1.5 -mt-1.5">
        <SocialLinks prefix="nav-mobile" size="sm" />
      </div>
    </motion.header>
  );
};
